module.exports = __webpack_public_path__ + "img/club-de-golf-pachuca.de834d4d.webp";